exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.clickable[data-v-2cf05e7c] {\n  cursor: pointer;\n}\n", ""]);

